import { render, staticRenderFns } from "./LegalAgreements.vue?vue&type=template&id=5597020b&"
import script from "./LegalAgreements.vue?vue&type=script&lang=ts&"
export * from "./LegalAgreements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports